<script>
import VSelect from '@alfsnd/vue-bootstrap-select';
import { BTable, BFormDatepicker, BInputGroup, BFormInput, BInputGroupAppend, BModal, BFormSelect } from 'bootstrap-vue'
import DibbleTranslation from "../../translation/translation";
import DibbleAPI from "../../api";
import DibbleJS from "../../dibble";

export default {
    name: "Message",
    components: {
        VSelect, BTable, BFormDatepicker, BFormSelect,
        BInputGroup, BFormInput, BInputGroupAppend, BModal
    },
    data() {
        return {            
            translate: DibbleTranslation,
            messageModal: {
                isOpen: false,
                isNew: false,
                title: DibbleTranslation.trans('pinker.message'),
                userMessage: "",
                message: {
                    number: 0,
                    system_message_id: 0,
                    isActive: true,
                    receiver_id: "",
                    receiver_name: "",
                    content: "",                    
                }
            },
            conversationModal: {
                isOpen: false,
                userId: '',
                userName: '',
                messages: [],
                title: DibbleTranslation.trans('pinker.details'),
                messageContent: "",                
            },
            filter_from_date: '',
            filter_to_date: '',
            filter_to_date_formatted: '',
            filter_to_date_selected: '',
            search: {
                keyword: '',
                status: {},
                country: {
                    value: null,
                    text: "-- None --"
                },
            },
            fields: [
                { key: 'created_date', label: DibbleTranslation.trans('pinker.dateTime'), sortable: true ,
                formatter: (value) => {
                    return value ? this.$moment(value).format('DD-MM-YYYY h:mm:ss') : ''
                  }},
                { key: 'username', label: DibbleTranslation.trans('pinker.username'), sortable: true },
                { key: 'message', label: DibbleTranslation.trans('pinker.content'), sortable: true },
                { key: 'message_status', label: DibbleTranslation.trans('pinker.status'), sortable: true},
                { key: 'details', label: DibbleTranslation.trans('pinker.details'), sortable: false },
            ],
            modalUsers: {
                title: DibbleTranslation.trans('pinker.recipientsList'),
                isOpen: false,
                userList: [],
            },
            selectedStatus: null,
            statusOptions: [
                { value: null, text: DibbleTranslation.trans('pinker.selectMessageStatus') },
                { value: 1, text: DibbleTranslation.trans('pinker.new') },
                { value: 2, text: DibbleTranslation.trans('pinker.pending') },
                { value: 3,  text: DibbleTranslation.trans('pinker.done') },
            ],
            messages: [],
            sourceMessages: [],
            pagination: {
                currentPage: 1,
                totalPage: 0
            },            
        }
    },
    mounted() {
        const scrollContent = document.getElementById('scroll-main-content')
        scrollContent.style.height = window.innerHeight*0.8 +  "px"
    },
    created() {
        this.loadMessages();
    },
    methods: {
        moment(value) {
            return this.$moment(value)
        },
        momentWithFormat(value, dateFormat) {
            return this.$moment(value, dateFormat)
        },
        formatDate(dateString) {
            return this.$moment(dateString).format('DD-MM-YYYY h:mm:ss');
        },
        onFilterchange: function (filterName, event) {
            if (filterName === "dateRangeFrom") {
                this.filter_from_date = event.target.value;
                this.filterUsers("date");
            } else if (filterName === "dateRangeTo") {
                this.filter_to_date = event.target.value;
                this.filterUsers("date");
            } else if (filterName === "status") {                
                this.filterUsers("status");
            }
        },
        showReceiptModal() {
            this.modalUsers.isOpen = true;
            this.loadReceipts()
        },
        closeReceiptModal() {
            this.modalUsers.isOpen = false;            
        },
        selectReceipt(receiptUser) {
            this.messageModal.message.receiver_id = receiptUser.user_id;
            this.messageModal.message.receiver_name = receiptUser.full_name;
            this.modalUsers.isOpen = false;
        },
        loadReceipts() {
            const params = {
                '#request': DibbleAPI.api.admin.getUsers,
                sort_direction: false,
            };
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, (data) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(data)) {
                    this.modalUsers.userList = data.users_list;                    
                } else {
                    DibbleJS.toastErrorMessage(data.message);
                }
            })
        },
        showMessageModal(feedbackItem, isNewNotification) {
            this.messageModal.isNew = isNewNotification;
            if (isNewNotification) {
                this.messageModal.title = this.translate.trans('pinker.addNewNotification')
            } else {

                this.messageModal.userMessage = feedbackItem.message
                this.messageModal.title = this.translate.trans('pinker.replyMessage')
                this.messageModal.message.receiver_id = feedbackItem.user_id
            }
            this.messageModal.isOpen = true
        },
        showDetailsConversation (feedbackItem) {
            const params = {
                '#request': DibbleAPI.api.getConversation,
                user_id: feedbackItem.user_id,
            };
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, (data) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(data)) {
                    this.conversationModal.messages = data.conversation.reverse()
                    this.conversationModal.userId = feedbackItem.user_id
                    this.conversationModal.userName = feedbackItem.username
                    this.conversationModal.title = feedbackItem.username
                    this.conversationModal.isOpen = true
                    this.scrollToLatestConversation()
                } else {
                    DibbleJS.toastErrorMessage(data.message);
                }
            })            
        },
        scrollToLatestConversation() {
            setTimeout(() => {
                if (this.$refs.bottomRefOfScroll) {
                    this.$refs.bottomRefOfScroll.scrollIntoView({behavior: 'smooth'});
                }
            }, 500)
        },
        closeDetailsConversation () {
            this.conversationModal.isOpen = false
            this.conversationModal.messageContent = ""
            this.conversationModal.messages = []
            this.conversationModal.userId = ''
        },
        closeMessageModal() {
            this.messageModal.isOpen = false
            this.messageModal.message.receiver_id = "";
            this.messageModal.message.receiver_name = "";
        },
        loadMessages(startDate = '', endDate = '') {
            const params = {
                '#request': DibbleAPI.api.admin.getAllMessages,
            };
            if (startDate !== '') {
                params.date_start = startDate
            }
            if (endDate !== '') {
                params.date_end = endDate
            }
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, this._onLoadMessageSuccess)
        },
        _onLoadMessageSuccess(responseData) {
            DibbleJS.hideLoader();
            if (DibbleAPI.isResponseSuccess(responseData)) {
                this.messages = responseData.system_messages;
                this.sourceMessages = responseData.system_messages;
                this.sourceMessages.map((item, index) => {
                    this.statusOptions.map(itemS => {
                        if (itemS.text === item.message_status) {
                            this.sourceMessages[index].message_status = itemS.value;
                            this.messages[index].message_status = itemS.value;
                        }
                        return "";
                    })
                    return "";
                })
            } else {
                DibbleJS.toastErrorMessage(responseData.message);
            }
        },
        searchUser (searhKey) {
            if (searhKey === "") {
                this.messages = this.sourceMessages
            } else {
                const tempList = []
                this.sourceMessages.map((item, index) => {
                    const fullname = item.username
                    if (fullname.toLowerCase().includes(searhKey.toLowerCase())){
                        tempList.push(item)
                    }
                    return item;
                })
                this.messages = tempList
            }
        },
        changeMessageStatus(item, status) {
            const params = {
              '#request': DibbleAPI.api.admin.upateMessageStatus,
              system_message_id: item.id,
              status: status
            };

            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, (responseData) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(responseData)) {
                  DibbleJS.toastSuccessMessage(responseData.message);
                  this.loadMessages();
                } else {
                  DibbleJS.toastErrorMessage(responseData.message);
                }
            })
        },
        updateMessageStatus (messageId, messageStatus) {
            const params = {
              '#request': DibbleAPI.api.admin.updateMessageStatus,
              system_message_id: messageId,
              status: messageStatus
            };

            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, (responseData) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(responseData)) {
                  DibbleJS.toastSuccessMessage(responseData.message);
                  this.loadMessages();
                } else {
                  DibbleJS.toastErrorMessage(responseData.message);
                }
            })
        },
        replyMessage (receiverId, content) {
            if (content !== "") {
                const params = {
                  '#request': DibbleAPI.api.admin.replyMessage,
                  user_id: receiverId,
                  message: content
                };
    
                DibbleJS.showLoader();
                DibbleJS.callApiRequest(params, (responseData) => {
                    DibbleJS.hideLoader();
                    if (DibbleAPI.isResponseSuccess(responseData)) {
                      DibbleJS.toastSuccessMessage(responseData.message);
                      this.closeMessageModal();
                      this.closeDetailsConversation()
                      this.loadMessages();
                    } else {
                      DibbleJS.toastErrorMessage(responseData.message);
                    }
                })
            }

        }
    }
}
</script>

<style>
    .user-image {
        width: 40px;
        height: 40px;
    }
    .v-dropdown-container {
        max-height: 250px;
        overflow-y: scroll;
    }
    .small-text-box {
        width: 50px
    }
    .medium-text-box {
        width: 120px
    }
    .circle-color {
        width: 20px;
        height: 20px;
        border-radius: 10px;
        background-color: brown;
    }
    .user-message {
        float: left;
        min-width: 30%;
        margin: 0px 5px 10px 5px;
        padding: 10px;
        border-radius: 0px 20px 20px 20px;
        background-color: rgb(243, 242, 242);
        text-align: left;
    }
    .admin-message {
        float: right;
        min-width: 30%;
        margin: 0px 5px 10px 5px;
        padding: 10px;
        border-radius: 20px 20px 0px 20px;
        background-color: rgb(226, 226, 226);
        text-align: right;
    }
    .msg-name {
        font-weight: bold;
        font-size: 15px;
        margin: 0px 0px 10px 0px
    }
    .msg-content {
        font-size: 18px;
        margin: 0px
    }
    .msg-date {
        font-size: 12px;
        font-style: italic;
        margin: 0px
    }
</style>

<template src="./Templates/Message.html"></template>


